import { HttpError, errorFields } from '../../../api';
import type { ErrorFactory } from '../../../api';
import i18n from '../../../i18n';
import type { SettingsViolation } from '../types/domain.types';

import { settingsViolationsSchema } from './schemas';

const NO_RESPONSE_STATUS = 0;

export class CtlApiError extends HttpError {
  readonly violations: readonly SettingsViolation[];
  readonly noResponse: boolean;

  constructor(opts: {
    status: number;
    message: string;
    code?: string | null;
    violations?: readonly SettingsViolation[];
    noResponse?: boolean;
    cause?: unknown;
  }) {
    super(opts);
    this.name = 'CtlApiError';
    this.violations = opts.violations ?? [];
    this.noResponse = opts.noResponse ?? false;
    this.cause = opts.cause;
  }
}

const hasMessage = (data: unknown): boolean => {
  const message = (data as { message?: unknown } | null | undefined)?.message;
  return typeof message === 'string' && message.length > 0;
};

export const ctlErrorFrom: ErrorFactory = (status, data) => {
  const noResponse = status === NO_RESPONSE_STATUS;
  const fields = errorFields(data);
  const message =
    noResponse && !hasMessage(data)
      ? i18n.t('closeTheLoop.states.noResponse', 'Couldn’t reach the server. Check your connection and try again.')
      : fields.message;
  const parsed = settingsViolationsSchema.safeParse((data as { violations?: unknown } | null | undefined)?.violations);
  return new CtlApiError({
    status,
    message,
    code: fields.code,
    violations: parsed.success ? parsed.data : [],
    noResponse,
    cause: data,
  });
};
